// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"49":"3f0f7269940a390d","538":"e1622820cf89140d","651":"6b0a0a214e3e799c","741":"a83780b663de33f6","781":"8a8c59dfb6fd090c","947":"7eb5a4e2fb97ba6f","976":"ba00b298bd9f15ae","983":"8f2d368b738ce0c7"}[chunkId] + ".js";
};